import { TRIAL_SIGNUP } from '../constants/signupConstants';
import { HubletUrl } from '../utils/urls';
import { ONBOARDING_VIEWS } from 'user-context/onboardingSettings';
import { TrialIds } from 'purchase-motions-components/constants/trial';
const trialExperiencesChecks = [{
  redirectPath: portalId => ({
    url: `${HubletUrl.getAppUrl()}/user-guide/${portalId}`,
    view: ONBOARDING_VIEWS.MARKETING
  }),
  checks: [{
    signupType: TRIAL_SIGNUP,
    searchParams: {
      trialId: `${TrialIds.MARKETING_PRO}`
    }
  }]
}, {
  redirectPath: portalId => ({
    url: `${HubletUrl.getAppUrl()}/user-guide/${portalId}`,
    view: ONBOARDING_VIEWS.MARKETING
  }),
  checks: [{
    signupType: TRIAL_SIGNUP,
    searchParams: {
      trialId: `${TrialIds.MARKETING_ENTERPRISE}`
    }
  }]
}, {
  redirectPath: portalId => ({
    url: `${HubletUrl.getAppUrl()}/user-guide/${portalId}`,
    view: ONBOARDING_VIEWS.SERVICE
  }),
  checks: [{
    signupType: TRIAL_SIGNUP,
    searchParams: {
      trialId: `${TrialIds.SERVICE_PROFESSIONAL}`
    }
  }]
}, {
  redirectPath: portalId => ({
    url: `${HubletUrl.getAppUrl()}/user-guide/${portalId}`,
    view: ONBOARDING_VIEWS.SERVICE
  }),
  checks: [{
    signupType: TRIAL_SIGNUP,
    searchParams: {
      trialId: `${TrialIds.SERVICE_ENTERPRISE}`
    }
  }]
}, {
  redirectPath: portalId => ({
    url: `${HubletUrl.getAppUrl()}/user-guide/${portalId}`,
    view: ONBOARDING_VIEWS.SALES
  }),
  checks: [{
    signupType: TRIAL_SIGNUP
  }]
}];
export default trialExperiencesChecks;